<template>
  <div class="course" :class="isAddDefaultCourseModuleShow ? 'flip' : ''">
    <courseList
      ref="courseList"
      class="course-list-component"
      @showCourseAdd="showCourseAdd"
      :courseList="courseList"
      @deleteCourse="deleteCourse"
      @updateCourse="updateCourse"
      @addCourse="submitCourseList"
      @showAddDefaultCourseModule="showAddDefaultCourseModule"
      :getCourseListResult="getCourseListResult"
      @submitCourseList="submitCourseList"
      @selectType="selectType"
    />
    <courseAdd
      class="add-course-component"
      :courseList="courseList"
      @cancel="cancel"
      @submitCourseList="submitCourseList"
    />
  </div>
</template>

<script>
import courseList from "./components/course-list/course-list.vue";
import courseAdd from "./components/course-add/course-add.vue";
import courseAddOther from "./components/course-add-other/course-add-other.vue";

import Vue from "vue";

export default {
  name: "",
  data() {
    return {
      // 当前学校选择的科目列表
      courseList: [],
      isAddDefaultCourseModuleShow: false,
      getCourseListResult: "nullData",
      courseType: "",
    };
  },
  components: {
    courseList,
    courseAdd,
    courseAddOther,
  },
  created() {
    // 获取学校当前科目列表
    this.getCourseList();
  },
  methods: {
    selectType(e) {
      this.courseType = e;
      this.getCourseList();
    },
    showAddDefaultCourseModule() {
      this.isAddDefaultCourseModuleShow = true;
    },
    // 获取学校当前科目列表
    getCourseList() {
      // this.getCourseListResult = "loading";
      this.get(this.$url.getCourseList, {
        schoolId: this.user.schoolId,
        courseType: this.courseType,
      })
        .then((res) => {
          // console.log("获取学校科目==>", res);
          if (res.rows === null) {
            this.getCourseListResult = "nullData";
            this.courseList = [];
            this.courseList = res.rows;
            this.isAddDefaultCourseModuleShow = false;
            return this.$message.warning("暂无设置科目，请添加设置");
          }
          if (res.code != 200) {
            this.getCourseListResult = "error";
            return this.$message.error("获取科目失败，请稍后再试");
          }
          this.courseList = [];
          this.courseList = res.rows;
          this.courseList.length > 0
            ? (this.getCourseListResult = "success")
            : (this.getCourseListResult = "nullData");
          this.isAddDefaultCourseModuleShow = false;
        })
        .catch((err) => {
          this.getCourseListResult = "error";
          this.$message.error("获取科目失败，请稍后再试");
        });
    },
    // 显示添加科目的选择列表
    showCourseAdd() {},
    // 取消添加科目
    cancel() {
      this.isAddDefaultCourseModuleShow = false;
    },
    // 添加科目
    submitCourseList(list) {
      this.post(this.$url.addCourse, list)
        .then((res) => {
          // console.log(res);
          if (res.code == 200 && res.data != 0) {
            this.$eventBus.$emit("addCourseSuccess");
            this.$message.success(res.msg);
            this.getCourseList();
          } else {
            this.$message.error(res.msg);
          }
          this.$eventBus.$emit("addCourseError");
        })
        .catch((err) => {
          this.$eventBus.$emit("addCourseError");
          this.$message.error(res.msg);
        });
    },
    // 修改科目
    updateCourse(options) {
      let data = {
        id: options.id,
        schoolId: this.user.schoolId,
        courseName: options.courseName,
        courseType: +options.courseType,
      };
      // 调用接口，成功后刷新 this.refresh()
      this.put(this.$url.putCourse, data)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.$refs.courseList.editPopupShow = false;
            this.$refs.courseList.editShow = "";
            // 刷新列表
            this.getCourseList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(res.msg);
        });
    },
    // 删除科目
    deleteCourse(item) {
      // console.log(item);
      // 调用接口，成功后刷新 this.refresh()
      this.delete(`${this.$url.deleteCourse}/${item.id}`)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$message.success("删除成功");
            // 刷新列表
            this.getCourseList();
          } else if (res.code == 500) {
            this.$message.warning(res.msg);
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch((err) => {
          this.$message.error("删除失败，请稍后重试");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./course.scss";
</style>
